export class PodStatus {
  private readonly _id: string;
  private readonly _name: string;
  private readonly _status: 'RUNNING' | 'STARTING' | 'STOPPED' | 'STOPPING' | 'ERROR';
  private readonly _gpuCount?: number;
  private readonly _costPerHour?: number;

  constructor(id: string, name: string, status: 'RUNNING' | 'STARTING' | 'STOPPED' | 'STOPPING' | 'ERROR', gpuCount?: number, costPerHour?: number) {
    this._id = id;
    this._name = name;
    this._status = status;
    this._gpuCount = gpuCount;
    this._costPerHour = costPerHour;
  }

  get id(): string {
    return this._id;
  }

  get name(): string {
    return this._name;
  }

  get status(): 'RUNNING' | 'STARTING' | 'STOPPED' | 'STOPPING' | 'ERROR' {
    return this._status;
  }

  get gpuCount(): number | undefined {
    return this._gpuCount;
  }

  get costPerHour(): number | undefined {
    return this._costPerHour;
  }

  isRunning(): boolean {
    return this._status === 'RUNNING';
  }

  public host(port: number = 8000): string {
    return `https://${this._id}-${port}.proxy.runpod.net`;
  }
}
